var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("AuthLayout", [
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.auth.apply(null, arguments)
          },
        },
      },
      [
        _c("div", { staticClass: "login-form__title" }, [
          _vm._v("Bienvenido de nuevo"),
        ]),
        _c("div", { staticClass: "login-form__subtitle" }, [
          _vm._v("Ingresá tus credenciales para acceder al panel de gestión."),
        ]),
        _c("div", { staticClass: "login-form__fields" }, [
          _vm.login_error != ""
            ? _c("div", { staticClass: "login-form__error" }, [
                _vm._v(
                  "Los datos ingresados son incorrectos. Vuelve a intentarlo"
                ),
              ])
            : _vm._e(),
          _c("div", [
            _c(
              "label",
              {
                staticClass: "login-form__label",
                attrs: { for: "login-email" },
              },
              [_vm._v("Email")]
            ),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.email,
                  expression: "email",
                },
              ],
              staticClass: "login-form__input",
              attrs: {
                id: "login-email",
                type: "text",
                placeholder: "nombre@empresa.com",
                autocomplete: "username",
                required: "",
              },
              domProps: { value: _vm.email },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.email = $event.target.value
                },
              },
            }),
          ]),
          _c("div", [
            _c(
              "label",
              {
                staticClass: "login-form__label",
                attrs: { for: "login-password" },
              },
              [_vm._v("Contraseña")]
            ),
            _c("div", { staticClass: "login-form__password" }, [
              (_vm.show ? "text" : "password") === "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    staticClass: "login-form__input",
                    attrs: {
                      id: "login-password",
                      placeholder: "••••••••",
                      autocomplete: "current-password",
                      required: "",
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.password)
                        ? _vm._i(_vm.password, null) > -1
                        : _vm.password,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.password,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.password = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.password = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.password = $$c
                        }
                      },
                    },
                  })
                : (_vm.show ? "text" : "password") === "radio"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    staticClass: "login-form__input",
                    attrs: {
                      id: "login-password",
                      placeholder: "••••••••",
                      autocomplete: "current-password",
                      required: "",
                      type: "radio",
                    },
                    domProps: { checked: _vm._q(_vm.password, null) },
                    on: {
                      change: function ($event) {
                        _vm.password = null
                      },
                    },
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    staticClass: "login-form__input",
                    attrs: {
                      id: "login-password",
                      placeholder: "••••••••",
                      autocomplete: "current-password",
                      required: "",
                      type: _vm.show ? "text" : "password",
                    },
                    domProps: { value: _vm.password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.password = $event.target.value
                      },
                    },
                  }),
              _c(
                "button",
                {
                  staticClass: "login-form__toggle",
                  attrs: {
                    type: "button",
                    "aria-label": _vm.show
                      ? "Ocultar contraseña"
                      : "Mostrar contraseña",
                  },
                  on: {
                    click: function ($event) {
                      _vm.show = !_vm.show
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v(_vm._s(_vm.show ? "mdi-eye" : "mdi-eye-off")),
                  ]),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "button",
            {
              staticClass: "login-form__submit",
              attrs: { type: "submit", disabled: _vm.loading },
            },
            [_vm._v(_vm._s(_vm.loading ? "Ingresando..." : "Iniciar sesión"))]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }